import { Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';

import { KeycloakService } from 'keycloak-angular';
import { jwtDecode } from 'jwt-decode';

import { environment } from '../../../environments/environment';
import { ChatService } from 'src/app/chat-module/services/chat.service';

import { UserService } from '../services/user.service';
import { UserSession } from '../interfaces/user.interface';

import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class KeycloakAuthService implements OnInit {
  accountUuid: string = '';
  wabaId: string = '';

  constructor(
    private keycloakSvc: KeycloakService,
    private http: HttpClient,
    private chatService: ChatService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  getToken() {

    sessionStorage.clear();
    localStorage.clear();

    if ('caches' in window) {
      caches.keys().then((names) => {
        for (let name of names) {
          caches.delete(name);
        }
      });
    }


    this.keycloakSvc.getToken().then((authToken) => {
      const accessToken = authToken;
      // save token access in sesionStorage
      // sessionStorage.setItem('accessToken', accessToken);
      this.saveUserInfoSession(accessToken);
    });
  }

  saveUserInfoSession(accessToken) {
    if (accessToken !== undefined) {
      // Decode token JWT
      const decodedToken: any = jwtDecode(accessToken);

      const keycloakUserId = decodedToken.sub;
      sessionStorage.setItem('kcUserId', keycloakUserId); // keycloakUserID

      const keycloakUserName = decodedToken.name; // keycloakUserName
      const userNameSplit = keycloakUserName.split(' ');
      const userName = userNameSplit.slice(0, 2).join(' ');
      sessionStorage.setItem('userName', userName);

      const keycloakEmail = decodedToken.email; //keycloakEmail
      sessionStorage.setItem('email', keycloakEmail);

      if (decodedToken.realm_access.roles) {
        const roles = decodedToken.realm_access.roles; //array roles

        roles.forEach((element) => {
          if (
            element === 'admin' ||
            element === 'supervisor' ||
            element === 'agente'
          ) {
            sessionStorage.setItem('rol', element);
          }
        });
      }

      this.getAccountUUID();
      this.getWorkGroupDefault(  );
    }
  }

  /*
  getAccountUUID() {
    const kcId = sessionStorage.getItem('kcUserId');
    const emailAgent = sessionStorage.getItem('email');

    const params = new HttpParams()
      .set('kc_id', kcId)
      .set('dynamic', emailAgent);
    this.http.get<any>(
        `${environment.url}/user-management/get-users-list-by-dynamic-variable`,
        { params }
      )
      .subscribe({
        next: (response) => {
          if (response[0] && response[0].accountUUID) {
            this.accountUuid = response[0].accountUUID;
            sessionStorage.setItem('accountUuid', this.accountUuid);
          }

          this.getWabaId();
        },
        error: (error) => {
          // console.error('Error :', error);
          sessionStorage.setItem('accountUuid', this.accountUuid);
          Swal.fire({
            title: 'Ayy no...',
            html: `
              <label> Ha ocurrido un error </label><br>
              <span> error ${error.status} </span><br>
              <b> Intenta más tarde </b>
            `,
            icon: "error",
            showCancelButton: false,
            showConfirmButton: true,
          });
        },
      });
  }*/

  getAccountUUID(): Promise<void> {
    return new Promise((resolve, reject) => {
      const kcId = sessionStorage.getItem('kcUserId');
      const emailAgent = sessionStorage.getItem('email');

      const params = new HttpParams()
        .set('kc_id', kcId)
        .set('dynamic', emailAgent);

      this.http.get<any>(
          `${environment.url}/user-management/get-users-list-by-dynamic-variable`,
          { params }
        )
        .subscribe({
          next: (response) => {
            if (response[0] && response[0].accountUUID) {
              this.accountUuid = response[0].accountUUID;
              sessionStorage.setItem('accountUuid', this.accountUuid);
              sessionStorage.setItem('oracleID', response[0].oracleID)
            }
            if(response[0] && response[0].workgroupList) {
              const workGroupIds = response[0].workgroupList.map(wg => wg.id);
              sessionStorage.setItem('workGroupsIds', JSON.stringify(workGroupIds));
            }

            resolve(); // Resuelve la promesa cuando la cuenta esté lista.
            this.getWabaId();
          },
          error: (error) => {
            sessionStorage.setItem('accountUuid', this.accountUuid);
            reject(error); // Rechaza la promesa en caso de error.
            Swal.fire({
              title: 'Ayy no...',
              html: `
                <label> Ha ocurrido un error </label><br>
                <span> error ${error.status} </span><br>
                <b> Intenta más tarde </b>
              `,
              icon: "error",
              showCancelButton: false,
              showConfirmButton: true,
            });
          },
        });
    });
  }


  getWabaId() {
    this.chatService.getWabaId(this.accountUuid).subscribe({
      next: (response) => {
        if (response.channel) {
          this.wabaId = response.channel.waba;
          sessionStorage.setItem('wabaId', this.wabaId);
          sessionStorage.setItem('phoneWabaId', response.channel.number)
        }
        this.generateSession();
      },
      error: (error) => {
        // console.error('Error :', error);
        sessionStorage.setItem('wabaId', this.wabaId);
        Swal.fire({
          title: 'Ayy no...',
          html: `
            <label> Ha ocurrido un error </label><br>
            <span> error ${error.status} </span><br>
            <b> Intenta más tarde </b>
          `,
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: true,
        });
        this.goToRoute('/main/no-autorized');
      },
      complete: () => {
        if(sessionStorage.getItem('wabaId') === '') {
          this.goToRoute('/main/no-autorized');
        }
      }
    });
  }

  generateSession() {
    this.userService
      .changeSessionStatus(sessionStorage.getItem('kcUserId'), 'online')
      .subscribe({
        next: (response: UserSession) => {
          if (response == null) {
            // console.error('Error :', error);
            Swal.fire({
              title: 'Ayy no...',
              html: `
          <label> Ha ocurrido un error </label><br>
          <span> error 500 </span><br>
          <b> Intenta más tarde </b>
        `,
              icon: 'error',
              showCancelButton: false,
              showConfirmButton: true,
            });
          }
        },
        error: (error) => {
          // console.error('Error :', error);
          Swal.fire({
            title: 'Ayy no...',
            html: `
      <label> Ha ocurrido un error </label><br>
      <span> error 500 </span><br>
      <b> Intenta más tarde </b>
    `,
            icon: 'error',
            showCancelButton: false,
            showConfirmButton: true,
          });
        },
      });
  }

  goToRoute(path: string): void {
    this.router.navigate([path], { relativeTo: this.route });
  }

  getWorkGroupDefault(){
    this.chatService.getWorkgroupDefault().subscribe({
      next: (response) => {
       sessionStorage.setItem('workGroupDefaultId',response.id)
      },
      error: (error) => {
        // console.error('Error :', error);
        sessionStorage.setItem('wabaId', this.wabaId);
        Swal.fire({
          title: 'Ayy no...',
          html: `
            <label> Ha ocurrido un error </label><br>
            <span> error ${error.status} </span><br>
            <b> Intenta más tarde </b>
          `,
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: true,
        });
      },
      complete: () => {

      }
    });
  }
}
